window.addEventListener('load', () => {
  const country_code = docCookies.getCookie('pc_geo');
  const localeObject = window._cmsCountries[country_code];

  if (localeObject) {
    const { phoneNumber } = localeObject;
    phoneNumber.length !== 0 && naturalizePhoneNumber(phoneNumber);
  }
});

const naturalizePhoneNumber = (phoneNumber, $childrenArray) => {
  const $contactNumbers = $childrenArray ? $childrenArray : document.querySelectorAll('.contact__li');

  for (let $contactNumber of $contactNumbers) {
    if ($contactNumber.children.length > 0) {
      naturalizePhoneNumber(phoneNumber, $contactNumber.children);
    } else if ($contactNumber.tagName.toLowerCase() === 'a') {
      $contactNumber.textContent = phoneNumber;
      $contactNumber.setAttribute('href', `tel:${phoneNumber}`);
      $contactNumber.setAttribute('data-track-click', `Navigation, Phone, ${phoneNumber}`);
    } else {
      $contactNumber.textContent = phoneNumber;
    }
  }
}
